export default __webpack_public_path__ + "static/media/roundup_Business_Model.a5248b5a.jpeg";